import { render, staticRenderFns } from "./Temperatura.vue?vue&type=template&id=0f6000d0&scoped=true&"
import script from "./Temperatura.vue?vue&type=script&lang=ts&"
export * from "./Temperatura.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6000d0",
  null
  
)

export default component.exports